export enum PassageDirections {
  IN = 'IN',
  OUT = 'OUT',
}
